var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWealth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4904_37140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5233 7.90433C10.2783 8.1435 10.1383 8.48766 10.1733 8.85516C10.2258 9.48516 10.8033 9.946 11.4333 9.946H12.5416V10.6402C12.5416 11.8477 11.5558 12.8335 10.3483 12.8335H3.65159C2.44409 12.8335 1.45825 11.8477 1.45825 10.6402V6.71433C1.45825 5.50683 2.44409 4.521 3.65159 4.521H10.3483C11.5558 4.521 12.5416 5.50683 12.5416 6.71433V7.55433H11.3633C11.0366 7.55433 10.7391 7.68266 10.5233 7.90433Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45825 7.23935V4.57352C1.45825 3.87935 1.88409 3.26102 2.53159 3.01602L7.16325 1.26602C7.33107 1.20278 7.51173 1.18121 7.68972 1.20315C7.86771 1.2251 8.03771 1.28991 8.18514 1.39202C8.33257 1.49413 8.45302 1.6305 8.53615 1.7894C8.61928 1.94831 8.66261 2.12502 8.66242 2.30435V4.52102M4.08325 7.00019H8.16659M13.1593 8.14936V9.35102C13.1593 9.67186 12.9027 9.93435 12.576 9.94602H11.4327C10.8027 9.94602 10.2252 9.48519 10.1727 8.85519C10.1377 8.48769 10.2777 8.14352 10.5227 7.90436C10.7385 7.68269 11.036 7.55435 11.3627 7.55435H12.576C12.9027 7.56602 13.1593 7.82852 13.1593 8.14936Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4904_37140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWealth);
export default __webpack_public_path__ + "static/media/wealth.cccb0fbcf995973a5a39a326d431c65a.svg";
export { ForwardRef as ReactComponent };